import React, { useRef, useState } from 'react';

import PropTypes from 'prop-types';
import { useHistory } from 'react-router-dom';
import Modal from '@tds/community-modal';

import { StatusBarWrapper } from '../design/statusBar/css';
import { BoxWrapper } from './css';
import { useLocalizedStringsContext } from '../context/LocalizedStringsContext';
import stringInterpolation from '../utils/stringInterpolation';
import request from '../utils/request';

const FormButtons = ({
  isFormTouched,
  isLastStep,
  nextStep,
  prevStep,
  saveAndExit,
  showSave,
  showSubmit,
  isSalesSupport,
  orderData,
  formName
}) => {
  const localizedStrings = useLocalizedStringsContext();
  const {
    formButtons: {
      submitButtonLabel,
      continueButtonLabel,
      saveContinueLaterButtonLabel,
      deleteOrder,
      createNewOrder,
      backButtonLabel
    },
    summaryForm: { modalBody, modalClose },
    headerLinks: { labelLogDefect }
  } = localizedStrings;
  const [isModalOpen, setModalOpen] = useState(false);
  const history = useHistory();
  const focusElementOnClose = useRef(null);

  return (
    <StatusBarWrapper>
      <div id="footer-wrapper">
        <BoxWrapper>
          {isSalesSupport && formName !== labelLogDefect && isLastStep ? (
            <>
              <button
                type="button"
                onClick={() => {
                  if (orderData && orderData.id) {
                    request
                      .delete(`/orders/${orderData.id}/delete-order`)
                      .then(() => {
                        setModalOpen(true);
                      });
                  }
                }}
                className="frg-button color-purple"
              >
                {deleteOrder}
              </button>
              <button
                type="button"
                style={{ marginLeft: '1rem' }}
                onClick={() => history.push('/')}
                className="frg-button color-green"
              >
                {createNewOrder}
              </button>
              <Modal
                heading=""
                bodyText={stringInterpolation(
                  modalBody,
                  orderData && orderData.orderId
                )}
                confirmCTAText={modalClose}
                onConfirm={() => history.push('/')}
                onClose={() => history.push('/')}
                isOpen={isModalOpen}
                focusElementAfterClose={focusElementOnClose}
              />
            </>
          ) : (
            <>
              <button
                type="button"
                onClick={prevStep}
                className="frg-button color-green"
              >
                {backButtonLabel}
              </button>
              {showSave && !isLastStep && (
                <button
                  type="button"
                  onClick={saveAndExit}
                  style={{ marginLeft: '1em' }}
                  className="frg-button color-purple"
                  disabled={!isFormTouched}
                >
                  {saveContinueLaterButtonLabel}
                </button>
              )}
              {showSubmit && (
                <button
                  type="button"
                  onClick={e => nextStep(e)}
                  style={{ marginLeft: '1em' }}
                  className="frg-button color-green"
                >
                  {isLastStep ? submitButtonLabel : continueButtonLabel}
                </button>
              )}
            </>
          )}
        </BoxWrapper>
      </div>
    </StatusBarWrapper>
  );
};

FormButtons.propTypes = {
  isFormTouched: PropTypes.bool.isRequired,
  isLastStep: PropTypes.bool.isRequired,
  nextStep: PropTypes.func.isRequired,
  prevStep: PropTypes.func.isRequired,
  saveAndExit: PropTypes.func.isRequired,
  showSave: PropTypes.bool,
  showSubmit: PropTypes.bool,
  isSalesSupport: PropTypes.bool.isRequired,
  orderData: PropTypes.shape({
    id: PropTypes.number,
    orderId: PropTypes.string
  }).isRequired,
  formName: PropTypes.string.isRequired
};

FormButtons.defaultProps = {
  showSave: true,
  showSubmit: true
};

export default FormButtons;
